module.exports = __webpack_public_path__ + "img/SSS-J-6.67ceec74.svg";